import { Box } from '@mui/material';
import { UserChip, type MissingUserDisplay } from './UserChip';

export type { MissingUserDisplay };

interface UsersChipListProps {
  userIds: string[];
  /** When the API returns 404 for a user: 'hide' shows nothing; 'show' shows "Unknown user". Defaults to 'show'. */
  missingUserDisplay?: MissingUserDisplay;
}

export function UsersChipList({ userIds, missingUserDisplay = 'hide' }: UsersChipListProps) {
  if (!userIds || userIds.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {userIds.map((userId, index) => (
        <UserChip
          key={`${userId}-${index}`}
          userId={userId}
          missingUserDisplay={missingUserDisplay}
        />
      ))}
    </Box>
  );
}
